<template>
    <div>
        <div class="table-responsive">
            <div class="form-inline ml-auto">
                <div class="button-group">
                  <button data-toggle="modal" data-target="#modalProductCostList" data-backdrop="static" data-keyboard="false" type="button" class="btn btn-soft-primary btn-sm" ><i class="fa fa-search" aria-hidden="true"></i> Sync</button>
                  <select v-model="company_no" class="btn btn-sm btn-outline-primary">
                    <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                  </select>
                  rows:
                  <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                    <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                  </select>
                  <span class="mr-1">
                    Total rows: <b>{{ rowsTotal }}</b>
                  </span>
                </div>
                <div class="form-group mx-sm-3 mb-2">
                    <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                </div>
                <span class="mr-1">
                  page:
                  <select v-model="currentPage">
                    <option v-for="p in pageLength" :key="p" :value="p">{{ p }}</option>
                  </select>
                  / {{ pageLength }}
                </span>
                <nav aria-label="Page navigation example" class="pull-right">
                    <ul class="pagination">
                        <li class="page-item">
                            <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                <i class="fa fa-angle-left" aria-hidden="true"></i>
                            </a>
                        </li>
                        <li class="page-item">
                            <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                <i class="fa fa-angle-right" aria-hidden="true"></i>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
            <ul class="nav nav-tabs nav-bordered">
              <li class="nav-item"><a href="#summary" data-toggle="tab" aria-expanded="false" class="nav-link active">Summary</a></li>
              <li class="nav-item"><a href="#raw" data-toggle="tab" aria-expanded="false" class="nav-link">Raw</a></li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane active" id="summary">
                <table class="table table-item mb-0 table-sm table-hover table-striped">
                  <thead>
                    <tr>
                      <th style="background-color: #244854; color: white;" class="text-center"></th>
                      <th colspan="4" class="text-center" style="background-color: #1A1A2E; color: white;">Masuk</th>
                      <th colspan="4" class="text-center" style="background-color: #3d3d75; color: white;">Keluar</th>
                      <th colspan="4" class="text-center" style="background-color: #6092a3; color: white;">Saldo</th>
                    </tr>
                    <tr>
                      <th style="background-color: #244854; color: white;" class="text-center">Date</th>
                      <!-- Stock Masuk -->
                      <th style="background-color: #1A1A2E; color: white;">Qty</th>
                      <th style="background-color: #1A1A2E; color: white;">Uom</th>
                      <th style="background-color: #1A1A2E; color: white;">Price</th>
                      <th style="background-color: #1A1A2E; color: white;">Ref No</th>
                      <!-- Stock Keluar -->
                      <th style="background-color: #3d3d75; color: white;">Qty</th>
                      <th style="background-color: #3d3d75; color: white;">Uom</th>
                      <th style="background-color: #3d3d75; color: white;">Price</th>
                      <th style="background-color: #3d3d75; color: white;">Ref No</th>
                      <!-- Stock Saldo -->
                      <th style="background-color: #6092a3; color: white;">Qty</th>
                      <th style="background-color: #6092a3; color: white;">Uom</th>
                      <th style="background-color: #6092a3; color: white;">Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="c in groupCost" :key="c.id">
                      <td><b>{{ c.date | dateFormat('DD/MM/YYYY') }}</b></td>
                      <td><span v-if="c.qtyIn !== 0">{{ c.qtyIn }}</span></td>
                      <td>{{ c.uomIn }}</td>
                      <td><span v-if="c.priceIn !== 0">{{ c.priceIn | currency }}</span></td>
                      <td>
                        <span v-for="(r, index) in c.refNoIn" :key="index">
                          <span v-if="r.status === 'inventory'" style="color: blue; cursor: pointer;" @click="showInventoryNo(r.ref_no)" data-toggle="modal" data-target="#modalInventoryForm" data-backdrop="static" data-keyboard="false">{{ r.ref_no }}, </span>
                          <span v-else style="color: blue; cursor: pointer;" @click="showPurchasingNo(r.ref_no)" data-toggle="modal" data-target="#modalPurchasing" data-backdrop="static" data-keyboard="false">{{ r.ref_no }}, </span>
                        </span>
                      </td>
                      <td><span v-if="c.qtyOut !== 0">{{ c.qtyOut }}</span></td>
                      <td>{{ c.uomOut }}</td>
                      <td><span v-if="c.priceOut !== 0">{{ c.priceOut | currency }}</span></td>
                      <td>
                        <span v-for="(r, index) in c.refNoOut" :key="index">
                          <span v-if="r.status === 'manufacture material'" style="color: blue; cursor: pointer;" @click="showManufactureNo(r.ref_no)" data-toggle="modal" data-target="#modalManufactureForm" data-backdrop="static" data-keyboard="false">{{ r.ref_no }}, </span>
                          <span v-else-if="r.status === 'sales'" style="color: blue; cursor: pointer;" @click="showSaleNo(r.ref_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">{{ r.ref_no }}, </span>
                        </span>
                      </td>
                      <td>{{ c.qtySaldo }}</td>
                      <td>{{ c.uomSaldo }}</td>
                      <td>{{ c.priceSaldo | currency }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="tab-pane" id="raw">
                <table class="table table-item mb-0 table-sm table-hover table-striped">
                    <thead>
                        <tr>
                            <th>
                                <label class="form-checkbox">
                                <input type="checkbox" v-model="selectAll" @click="select">
                                <i class="form-icon"></i>
                                </label>
                            </th>
                            <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)">
                                {{ t.name }}
                                <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="filterData.length < 1">
                            <td colspan="12" style="text-align: center;"><i>No Data</i></td>
                        </tr>
                        <tr v-for="ct in filterData" :key="ct.id" style="cursor: pointer">
                            <td><label class="form-checkbox"><input type="checkbox" :value="ct.id" v-model="selected" class="custom--checkbox"><i class="form-icon"></i></label></td>
                            <td>
                                <span class="badge badge-success" v-if="ct.status === 'purchasing'">{{ ct.status }}</span>
                                <span class="badge badge-warning" v-else-if="ct.status === 'sales'">{{ ct.status }}</span>
                                <span class="badge badge-secondary" v-else-if="ct.status === 'inventory'">{{ ct.status }}</span>
                                <span class="badge badge-warning" v-else-if="ct.status === 'manufacture material'">{{ ct.status }}</span>
                                <span class="badge badge-primary" v-else>{{ ct.status }}</span>
                            </td>
                            <td>{{ ct.type }}</td>
                            <td>{{ ct.queue }}</td>
                            <td>{{ ct.cost_date | dateFormat('DD/MM/YYYY') }}</td>
                            <td>{{ ct.ref_no }}</td>
                            <td>{{ ct.cost_qty }}</td>
                            <td>{{ ct.uom_id }}</td>
                            <td>{{ ct.cost_amount | currency }}</td>
                            <td>{{ ct.cost_average | currency }}</td>
                        </tr>
                    </tbody>
                </table>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6"><pre>{{ groupCost }}</pre></div>
              <div class="col-md-6"><pre>{{ costs }}</pre></div>
            </div>
        </div>
        <ProductCostListModal @getSyncData="getSyncData"/>
        <InventoryFormModal/>
        <PurchasingModal />
        <SaleModal />
        <ManufactureFormModal />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import ProductCostListModal from '@/components/product/ProductCostListModal.vue'
import InventoryFormModal from '@/components/inventory/InventoryFormModal.vue'
import PurchasingModal from '@/components/purchasing/PurchasingModal.vue'
import SaleModal from '@/components/sales/SaleModal.vue'
import ManufactureFormModal from '@/components/manufacture/ManufactureFormModal.vue'
import Axios from 'axios'
import { getHeader, productUrl } from '../../config'
export default {
  name: 'ProductCostList',
  props: ['costs', 'product'],
  components: {
    ProductCostListModal,
    InventoryFormModal,
    PurchasingModal,
    SaleModal,
    ManufactureFormModal
  },
  data () {
    return {
      company_no: 'C0002',
      publicPath: process.env.BASE_URL,
      dateNow: new Date(),
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#6ED861',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      filterCategory: [],
      filterType: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1,
      title: [{
        name: 'Status',
        prop: 'status'
      }, {
        name: 'Type',
        prop: 'type'
      }, {
        name: 'Queue',
        prop: 'queue'
      }, {
        name: 'Date',
        prop: 'cost_date'
      }, {
        name: 'Ref No.',
        prop: 'ref_no'
      }, {
        name: 'Qty',
        prop: 'qty'
      }, {
        name: 'Uom',
        prop: 'uom_id'
      }, {
        name: 'Price',
        prop: 'cost_amount'
      }, {
        name: 'Avg. COGS',
        prop: 'cost_average'
      }],
      selectAll: false,
      selected: []
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser,
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList
    }),
    groupCost () {
      var result = []
      if (this.costs.length > 0) {
        this.costs.filter(d => d.company_no === this.company_no).reduce(function (res, value) {
          if (!res[value.cost_date]) {
            var qtyIn = 0
            var qtyOut = 0
            var qtySaldo = 0
            var uomIn = null
            var uomOut = null
            var uomSaldo = null
            var priceIn = 0
            var priceOut = 0
            var priceSaldo = 0
            var refNoIn = []
            var refNoOut = []
            if (value.type === 'in') {
              console.log('value type in')
              console.log(value)
              qtyIn = value.cost_qty
              uomIn = value.uom_id
              priceIn = value.cost_amount
              refNoIn.push({
                ref_no: value.ref_no,
                status: value.status
              })
            } else if (value.type === 'out') {
              console.log('value type out')
              console.log(value)
              qtyOut = value.cost_qty
              uomOut = value.uom_id
              priceOut = value.cost_amount
              refNoOut.push({
                ref_no: value.ref_no,
                status: value.status
              })
            } else if (value.type === 'saldo') {
              console.log('value type saldo/current ')
              console.log(value)
              qtySaldo = value.cost_qty
              uomSaldo = value.uom_id
              priceSaldo = value.cost_average
            }
            res[value.cost_date] = {
              date: value.cost_date,
              qtyIn: qtyIn,
              uomIn: uomIn,
              priceIn: priceIn,
              refNoIn: refNoIn,
              qtyOut: qtyOut,
              uomOut: uomOut,
              priceOut: priceOut,
              refNoOut: refNoOut,
              qtySaldo: qtySaldo,
              uomSaldo: uomSaldo,
              priceSaldo: priceSaldo
            }
            result.push(res[value.cost_date])
          } else {
            if (value.type === 'in') {
              console.log('value type in')
              res[value.cost_date].qtyIn = parseFloat(res[value.cost_date].qtyIn) + parseFloat(value.cost_qty)
              res[value.cost_date].priceIn = value.cost_amount
              res[value.cost_date].uomIn = value.uom_id
              res[value.cost_date].refNoIn.push({
                ref_no: value.ref_no,
                status: value.status
              })
            } else if (value.type === 'out') {
              console.log('value type out')
              res[value.cost_date].qtyOut = parseFloat(res[value.cost_date].qtyOut) + parseFloat(value.cost_qty)
              res[value.cost_date].priceOut = value.cost_amount
              res[value.cost_date].uomOut = value.uom_id
              res[value.cost_date].refNoOut.push({
                ref_no: value.ref_no,
                status: value.status
              })
            } else if (value.type === 'saldo') {
              console.log('value type saldo/current ')
              console.log(value.ref_no)
              console.log(value.cost_average)

              res[value.cost_date].qtySaldo = parseFloat(value.cost_qty)
              res[value.cost_date].uomSaldo = value.uom_id
              res[value.cost_date].priceSaldo = value.cost_average
            }
          }
          return res
        }, {})
      }
      // return result
      var col = 'date'
      var ascending = true
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return result.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.costs.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (var name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        var start = (this.currentPage - 1) * this.pageSize
        var end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    showSaleNo (no) {
      var payload = {
        sale_no: no
      }
      this.$store.commit('SET_SALE_BY_NO', payload)
      this.$store.dispatch('getSaleByNo', payload)
    },
    showManufactureNo (no) {
      var payload = {
        manufacture_no: no
      }
      this.$store.commit('SET_MANUFACTURE_BY_NO', payload)
      this.$store.dispatch('getManufactureByNo', payload)
    },
    showInventoryNo (no) {
      var payload = {
        inventory_no: no
      }
      this.$store.commit('SET_INVENTORY_BY_NO', payload)
      this.$store.dispatch('getInventoryByNo', payload)
    },
    showPurchasingNo (no) {
      var payload = {
        purchasing_no: no
      }
      this.$store.commit('SET_PURCHASING_ID', payload)
      this.$store.dispatch('getPurchasingShowByNo', payload)
    },
    async getSyncData (value) {
      var date = new Date(value.date)
      var newDate = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate()
      var obj = {
        date: newDate,
        product_no: this.product,
        type: 'all',
        company_no: value.company_no
      }
      console.log(obj)
      await Axios.post(productUrl + '/cost/sync', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          this.$emit('backCost')
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (var i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    }
  }
}
</script>
